// extracted by mini-css-extract-plugin
export default {"edit":"edit-DGaB","form":"form-clFe"};